module.exports = __webpack_public_path__ + "static/media/all.62621651.svg";